import { useContext } from 'react'
import NavigationContext from './navigationContext'

export default () => useContext(NavigationContext)
